// Joy Wishlist (App) setzt fuer seinen Herz-Button per Inline-Style
// --joy-wl-tooltip-color:#000000 -- das ist die TEXTFARBE des Tooltips,
// dessen Hintergrund selbst dunkel ist (rgba(0,0,0,0.8)) -> schwarzer Text auf
// schwarzem Grund, praktisch unlesbar (User-Feedback 2026-10-01). Die Variable
// steckt im offenen Shadow DOM des Buttons, inline auf dem Button-Element
// selbst gesetzt -- von aussen per Theme-CSS nicht ueberschreibbar (eine
// externe Regel auf einem Vorfahren verliert gegen die eigene Inline-Angabe
// des Elements). Deshalb per JS direkt im Shadow DOM patchen.
//
// Der Button ist ein Lit-Web-Component und rendert sein eigenes
// style-Attribut bei jedem internen Re-Render (Hover, Wishlist-Status-Wechsel
// irgendwo auf der Seite, ...) komplett neu aus seinem eigenen, unveraenderten
// State -- ein einmaliges Patchen wird dadurch beim naechsten Re-Render
// wieder ueberschrieben. Deshalb ein dauerhafter attribute-Observer auf dem
// style-Attribut, der den Wert bei jeder Aenderung erneut korrigiert.

function ensureFixed(inner) {
  if (inner.style.getPropertyValue('--joy-wl-tooltip-color') !== '#ffffff') {
    inner.style.setProperty('--joy-wl-tooltip-color', '#ffffff');
  }
}

function watchInnerButton(inner) {
  ensureFixed(inner);
  if (inner.dataset.tooltipObserverAttached) return;
  inner.dataset.tooltipObserverAttached = 'true';
  const attrObserver = new MutationObserver(() => ensureFixed(inner));
  attrObserver.observe(inner, { attributes: true, attributeFilter: ['style'] });
}

function watchWishlistButton(button) {
  const tryFind = () => {
    const inner = button.shadowRoot && button.shadowRoot.querySelector('.Joy-Wishlist__Button');
    if (inner) {
      watchInnerButton(inner);
      return true;
    }
    return false;
  };
  if (tryFind() || !button.shadowRoot) return;
  // Shadow-Inhalt wird teils asynchron (Lit) nachgerendert -- auf das
  // Erscheinen des inneren Buttons warten statt fest zu verzoegern.
  const shadowObserver = new MutationObserver(() => {
    if (tryFind()) shadowObserver.disconnect();
  });
  shadowObserver.observe(button.shadowRoot, { childList: true, subtree: true });
}

const bodyObserver = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType !== 1) return;
      if (node.tagName === 'JOY-WISHLIST-BUTTON') watchWishlistButton(node);
      node.querySelectorAll && node.querySelectorAll('joy-wishlist-button').forEach(watchWishlistButton);
    });
  }
});
bodyObserver.observe(document.body, { childList: true, subtree: true });

// <joy-wishlist-button>-Tags koennen schon im HTML stehen, bevor die App
// ihr eigenes Script geladen und das Custom Element registriert hat --
// bis dahin existiert .shadowRoot noch nicht. Erst nach der Registrierung
// (whenDefined) hat ein sofortiger Durchlauf ueberhaupt eine Chance.
if (document.querySelector('joy-wishlist-button')) {
  customElements.whenDefined('joy-wishlist-button').then(() => {
    document.querySelectorAll('joy-wishlist-button').forEach(watchWishlistButton);
  });
}
